<template>
  <div id="Faq">
    <div class="banner">
      <img src="/static/images/faq/m_faq_bg.png" alt=""><div class="bannerText">
      <div class="title">{{$t("faq.bannerText")}}</div>
        <div class="titleSub">{{$t("faq.bannerDetail")}}</div>
      </div>
    </div>
    <div class="content">
      <van-tabs v-model="active" :offset-top='50' line-width='33.3%' :ellipsis=false animated  color='#27C2B4' sticky title-active-color='#27C2B4'  :swipe-threshold=3 swipeable>
        <van-tab :title="$t(item.name)" v-for="(item,index) in list" :key="item.name">
          <div class="con">
            <div class="que" v-if="index==0">
              <div v-for="item in queList1" :key="(item.title,item.detail)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail">{{$t(item.detail)}}</div>
                </div>
              </div>
            </div>
            <div class="que" v-if="index==1">
              <div v-for="item in queList2" :key="(item.title,item.detail)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail">{{$t(item.detail)}}</div>
                </div>
              </div>
            </div>
            <div class="que" v-if="index==2">
              <div v-for="(item,index) in queList3" :key="(item.title,item.detail,index)">
                <div class="queBox">
                  <div class="queTitle">{{$t(item.title)}}</div>
                  <div class="queDetail" v-if="index!==2">{{$t(item.detail)}}</div>
                  <div class="queDetail flexBox" v-if="index===2">
                    <div class="kfBox">
                      <div class="name">{{$t(item.detail.name1)}}</div>
                      <div><img :src="item.detail.img1" alt=""></div>
                    </div>
                    <div class="kfBox">
                      <div class="name">{{$t(item.detail.name2)}}</div>
                      <div><img :src="item.detail.img2" alt=""></div>
                    </div>
                    <div class="kfBox">
                      <div class="name">{{$t(item.detail.name3)}}</div>
                      <div><img :src="item.detail.img3" alt=""></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>

export default {
  data() {
    return {
      active:0,
      list:[
        {
          name:'faq.listName1'
        },
        {
          name:'faq.listName2'
        },
        {
          name:'faq.listName3'
        }
      ],
      queList1:[
        {
          title:'faq.queList1.title1',
          detail:'faq.queList1.detail1'
        },
        {
          title:'faq.queList1.title2',
          detail:'faq.queList1.detail2'
        },
        {
          title:'faq.queList1.title3',
          detail:'faq.queList1.detail3'
        },
        {
          title:'faq.queList1.title4',
          detail:'faq.queList1.detail4'
        },
        {
          title:'faq.queList1.title5',
          detail:'faq.queList1.detail5'
        },
        {
          title:'faq.queList1.title6',
          detail:'faq.queList1.detail6'
        },
        {
          title:'faq.queList1.title7',
          detail:'faq.queList1.detail7'
        },
        {
          title:'faq.queList1.title8',
          detail:'faq.queList1.detail8'
        },
        {
          title:'faq.queList1.title9',
          detail:'faq.queList1.detail9'
        },
        {
          title:'faq.queList1.title10',
          detail:'faq.queList1.detail10'
        }
      ],
      queList2:[
        {
          title:'faq.queList2.title1',
          detail:'faq.queList2.detail1'
        },
        {
          title:'faq.queList2.title2',
          detail:'faq.queList2.detail2'
        },
        {
          title:'faq.queList2.title3',
          detail:'faq.queList2.detail3'
        },
        {
          title:'faq.queList2.title4',
          detail:'faq.queList2.detail4'
        }
      ],
       queList3:[
        {
          title:'faq.queList3.title1',
          detail:'faq.queList3.detail1'
        },
        {
          title:'faq.queList3.title2',
          detail:'faq.queList3.detail2'
        },
        {
          title:'faq.queList3.title3',
          detail:{
            name1:'nelsoftkefu001',
            img1:'/static/images/faq/img1.png',
            name2:'nelsoftkefu002',
            img2:'/static/images/faq/img2.png',
            name3:'nelsoftkefu003',
            img3:'/static/images/faq/img3.png',
          }
        },
        {
          title:'faq.queList3.title4',
          detail:'faq.queList3.detail4'
        }
      ],
      selectId:0
    };
  },
  //定义这个sweiper对象
  computed: {},
  created:function () {
    window.scroll(0, 0);
    this.$emit('menuHiddens');
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll);
    if (this.$getCookie("langs") == "en") {
      this.lang_en = true;
    } else {
      this.lang_en = false;
    }
    this.show=true
  },
  methods: {
    clickList(id){
      this.selectId = id
    },
  }
};
</script>
<style scoped lang="less" type="text/less">
#Faq{
  margin-top: 50px;
  .banner{
    position: relative;
    img{
      width: 100%;
    }
    .bannerText{
      position:absolute;
      top: 20%;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      padding: 0 10px;
      color: #fff;
      .title{
        font-size: 3rem;
        font-weight: bold;
        position: relative;
      }
      .titleSub{
        font-size: 1.6rem;
        max-width: 600px;
      }
    }
  }
  .content{
    padding: 0;
    min-height: 400px;
    padding: 0 5px;
    // width: 80%;
    // margin: 0 auto;
    & /deep/ .van-tabs .van-tab span{
      font-size:1.4rem;
    }
    .con{
      width: 80%;
      margin: 0 auto;
      .que{
        padding: 2rem 0;
        .queBox{
          .queTitle{
            font-size: 1.8rem;
            color: #333;
            font-weight: bold;
          }
          .queDetail{
            font-size: 1.4rem;
            color: #666;
            padding: 10px 0 30px 0;
            white-space: pre-line;
          }
          .flexBox{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            .kfBox{
              margin-right: 1rem;
              .name{
                font-size: 1.3rem;
              }
              img{
                width: 100%;
              }
            }
          }
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile/Faq/Faq.vue